import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import TargetRightHandLinks from '@Components/Results/targets/TargetRightHandLinks';
import TargetDetailsLeft from '@Components/Results/targets/TargetDetailsLeft';

function TargetBasicDetails({ metadata, target, onDetailsToggle, detailsExpanded, trackingAttrs }) {
  const subunits = target.subunits || [];

  return (
    <div className="target-details-container">
      <div className={`target-details${subunits.length > 1 ? ' target-details--complex' : ''}`}>
        <TargetDetailsLeft
          subunits={subunits}
          detailsExpanded={detailsExpanded}
          onDetailsToggle={onDetailsToggle}
          trackingAttrs={trackingAttrs}
        />
        <TargetRightHandLinks metadata={metadata} target={target} />
      </div>
    </div>
  );
}

TargetBasicDetails.propTypes = {
  metadata: MetadataPropTypesShape,
  target: PropTypes.object.isRequired,
  detailsExpanded: PropTypes.bool.isRequired,
  onDetailsToggle: PropTypes.func.isRequired,
  trackingAttrs: PropTypes.object.isRequired,
};

export default TargetBasicDetails;
